import { render } from "./BottomSection.vue?vue&type=template&id=d82c90f6&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"

import "./BottomSection.vue?vue&type=style&index=0&id=d82c90f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82c90f6"]])

export default __exports__